// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

// PC Cudris
// const baseurl = 'http://192.168.1.19/unidrogas/public/api/';
// Backend VPS
// const baseurl = 'https://api.litofarma.com/api/';
// Backend DEV
const baseurl = 'https://dev.litofarma.com/api/';

// Servidor Centos
// const baseurl = 'http://sistemas.binar10.co/unidrogas_api/public/api/';

export const environment = {
  production: false,
  apibase: 'https://dev.litofarma.com',
  apibase2: 'https://api.unidrogas.com',
  _grantClient: 'HtVlCdYlRJuMWOgEtJtGN2NMIYmnP4u8GeyGz1sU',
  /**
   * Módulo Home-page
   * Web de inicio
   */
  unidrogas_home: {
    getBannersWeb: baseurl + 'allBannerHeaderActivos',
    getProductos: baseurl + 'allBannerProductoTfActivos',
    getAllModulosBanners: baseurl + 'getModuloEmpleado',
    contacto: {
      VER_TIPO_USUARIO: baseurl + 'getTipoUsuarioContactos',
      formulario_proveedor: baseurl + 'ContactoProveedor',
      formulario_cliente: baseurl + 'ContactoCliente',
      buscar_ciudad: baseurl + 'BuscarCiudad/',
    },
  },
  /**
   * Módulo Contenido para Empleados
   */
  employees_content: {
    banners: {
      BANNERS: baseurl + 'allBannerEmpleadoAdmin',
      /**
       * POST - Crea un banner
       */
      CREATE_BANNER: baseurl + 'CrearBannerEmpleado',
      /**
       * POST - Edita un banner
       */
      EDIT_BANNER: baseurl + 'actualizarBannerEmpleado',
      /**
       * POST - Elimina un banner
       */
      DELETE_BANNER: baseurl + 'eliminarBanner',
      /**
       * POST - Edita la posición de los banners
       */
      EDIT_POSITION_BANNER: baseurl + 'editarPosicionBanner',
      /**
       * POST - Activa o desactiva un banner
       */
      EDIT_STATE_BANNER: baseurl + 'cambiarEstadoBanner',
      /**
       * GET - Trae los banners para los empleados
       */
      EMPLOYEES_BANNERS: baseurl + 'allBannerEmpleado',
    },
  },
  /**
   * Módulo Creación de Contenido
   */
  content: {
    // RUTAS ADMIN
    POST_CREATE_ARTICLE: baseurl + 'crearContenido',
    GET_CONTENT_CREATED: baseurl + 'getContenidoAdmin',
    POST_UPDATE_ARTICLE: baseurl + 'actualizarContenido',
    GET_CONTENT_TYPES: baseurl + 'getTipoContenido',
    GET_VISIBILITY_TYPES: baseurl + 'getVisibilidadContenido',
    // RUTAS PARA EMPLEADOS
    GET_EMPLOYEE_NEWS: baseurl + 'getNoticiasEmpleados',
    GET_EMPLOYEE_POSTS: baseurl + 'getContenidoBlogEmpleado',
    GET_EMPLOYEE_POST_DETAILS: baseurl + 'verDetalleContenido',
    GET_UNINOTAS_MAGAZINES_FOR_EMPLOYEE: baseurl + 'getUninotasEmpleados',
    POST_COUNT_MAGAZINE: baseurl + 'contadorUninota',
  },
  /**
   * Módulo Uninotas
   */
  uninotas: {
    GET_MAGAZINE_LIST: baseurl + 'getUninotasAdmin',
    POST_CREATE_MAGAZINE: baseurl + 'crearUninota',
    POST_UPDATE_MAGAZINE: baseurl + 'updateUninota',
    POST_DELETE_MAGAZINE: baseurl + 'eliminarUninota',
  },
  /**
   * Módulo PQRS del lado del cliente
   */
  pqrs_client: {
    CREATE_PQRS: baseurl + 'CrearPqr',
    GET_DOCUMENT_TYPE: baseurl + 'getTipoDocumentoContactos',
    GET_REQUEST_TYPE: baseurl + 'getTipoSolicitudContactos',
    GET_USER_TYPE: baseurl + 'getTipoUsuarioContactos',
    GET_DEPARTMENTS: baseurl + 'getDepartamentos',
    GET_CITIES: baseurl + 'getCiudadesPorDepto/', // recibe {id_depto?}
    GET_PQRS_DETAILS: baseurl + 'buscarConsecutivoUsuario/',
    POST_MESSAGE_USER: baseurl + 'addMensajePqrUsuario',
  },
  /**
   * Módulo PQRS del lado del administrador
   * Dashboard Web
   */
  pqrs_admin: {
    GET_PQRS_LIST: baseurl + 'getAllPqr',
    GET_PQRS_STATUS: baseurl + 'getEstados',
    GET_PQRS_DETAILS: baseurl + 'verDetallePqr/',
    POST_CANCEL_PQRS: baseurl + 'cancelarPqr',
    POST_FINALIZE_PQRS: baseurl + 'FinalizarPqr',
    POST_PROCESAR_PQRS_PENDIENTE: baseurl + 'procesarPqrPendientes',
    POST_ADD_CHAT_RESPONSE_PQRS: baseurl + 'addRespuestaPqrProcesoAdmin',
    POST_ADD_CORREO_HISTORIAL_PQRS: baseurl + 'addRespuestaEmailPqrProceso',
    GET_NOTIFICATIONS: baseurl + 'allNotificacionChatPqr',
    POST_MARK_READ_NOTIFICATION: baseurl + 'LeerNotificaciones',
  },
  /**
   * Módulo Trabaje con Nosotros
   * del lado del cliente
   */
  work_with_us: {
    GET_CITIES: baseurl + 'getAllCiudades',
    GET_MUNICIPIOS: baseurl + 'getMunicipios',
    GET_MUNICIPIOS_DK: baseurl + 'getMunicipiosDkCiudad/',
    GET_TYPES_CHARGES: baseurl + 'getAllTiposCargos',
    GET_CHARGE_BY_TYPE: baseurl + 'getCargosPorTipo/',
    POST_REGISTER_CV: baseurl + 'registrarHojaVida',
  },
  /**
   * Módulo Trabaje con Nosotros
   * del lado del administrador
   */
  work_with_us_admin: {
    GET_ALL_CV: baseurl + 'getAllHojasVida',
    POST_MARK_AS_READ: baseurl + 'marcarLeidaHv',
    POST_MARK_AS_IMPORTANT: baseurl + 'marcarPrioritariaHv',
    POST_DELETE_CV: baseurl + 'eliminarHv',
    GET_CV_FILTERS: baseurl + 'scopeFiltroHv',
  },
  /**
   * Módulo Banners, Productos en teleferia
   * Banners, login, empleados de unidrogas, etc.
   * Dashboard Web
   */
  dashboard_web: {
    login: baseurl + 'loginNew',
    roles: baseurl + 'GetRolesUser',
    POST_FORGOT_PASSWORD_EMPLOYEE: baseurl + 'RecuperarContrasenaEmpleado',
    POST_UPDATE_PASSWORD_EMPLOYEE: baseurl + 'verificarContrasenaEmpleado',
    // USER_VALIDATION: Se chequea que el usuario/empleado tenga su correo validado
    USER_VALIDATION: baseurl + 'validarEstadoLoginEmpleado',
    // USER_SEND_MAIL_VALIDATION_CODE: En caso de no tenerlo, se envía un código al correo
    USER_SEND_MAIL_VALIDATION_CODE: baseurl + 'VerificacionCorreoEmpleado',
    // USER_SEND_RECEIVED_VALIDATION_CODE: Envío del código recibido al correo
    USER_SEND_RECEIVED_VALIDATION_CODE: baseurl + 'ValidacionCodigoEmpleado',
    // EMPLEADO_UNIDROGAS_HOME: Datos del Empleado de Unidrogas
    EMPLEADO_UNIDROGAS_HOME: baseurl + 'homeEmpleado',
    // EMPLEADO GENERAL UNIDROGAS
    empleado_general: {
      POST_SUBIR_FOTO_EMPLEADO: baseurl + 'subirFotoEmpleado',
      POST_ELIMINAR_FOTO_EMPLEADO: baseurl + 'eliminarFoto',
    },
    // DESCARGA DE CERTIFICADOS - Laboral / Fuentes y Retenciones
    DOWNLOAD_CERT_EMPLEADO_UNIDROGAS_POST: baseurl + 'certificadosEmpleado',
    COMPROBANTE_PAGO_TIRESIA: baseurl + 'comprobantePagoTiresia',
    banners: {
      crearBanner: baseurl + 'CrearBanner',
      bannersTypes: baseurl + 'allTipoBanner',
      getBannersDashboard: baseurl + 'AllBanner',
      getBannersFromType: baseurl + 'AllBanner/',
      verBanner: baseurl + 'VerBanner/',
      eliminarBanner: baseurl + 'EliminarBanner',
      updateBanner: baseurl + 'UpdateBanner',
      activarBanner: baseurl + 'ActivarBanner',
      desactivarBanner: baseurl + 'DesactivarBanner',
      editarPosicionesBanners: baseurl + 'editarPosicionesBanners',
    },
    featured_products: {
      crear_producto: baseurl + 'CrearProductoTeleferia',
      ver_productos: baseurl + 'VerAllBannerProductoTeleferia',
      activar_producto: baseurl + 'ActivarBannerProduct',
      desactivar_producto: baseurl + 'DesactivarBannerProduct',
      ver_detalle_producto: baseurl + 'VerBannerProductoTeleferia/',
      editarPosicionesProductos: baseurl + 'editarPosicionesBannersProductos',
      actualizar_producto: baseurl + 'UpdateBannerProductoTeleferia',
      eliminar_producto: baseurl + 'EliminarBannerProduct',
      buscar_producto: baseurl + 'buscadorProductos/',
    },
  },
  /**
   * Módulo de laboratorios
   * Dashboard Web
   */
  labs: {
    ALL_LABS: baseurl + 'allLaboratorioActivos',
    SEARCH_LAB: baseurl + 'BuscarLaboratoriosAdmin/',
    SEARCH_LAB_CLIENT: baseurl + 'BuscarLaboratoriosCliente/',
    UPLOAD_PDF_LAB: baseurl + 'subirPdfLaboratorios',
    UPDATE_PDF_LAB: baseurl + 'editarPdfLaboratorios',
    DEACTIVATE_LAB: baseurl + 'desactivarLaboratorio',
    ACTIVATE_LAB: baseurl + 'activarLaboratorio',
  },
  /**
   * Módulo de administración de usuarios
   */
  admin_users: {
    USERS_LIST_GET: baseurl + 'getAllUsers',
    ROLES_LIST_GET: baseurl + 'getRolesAdmin',
    CREATE_USER_POST: baseurl + 'crearUsuario',
    USER_ASSIGN_ROLE_POST: baseurl + 'asignarRolesUser',
    USER_UPDATE_INFO_POST: baseurl + 'updateInfoUsers/',
    USER_ACTIVATE_DEACTIVATE_POST: baseurl + 'activarODesactivarUser',
    USER_SEE_DETAILS_GET: baseurl + 'verDetalleUsers/',
    USER_REMOVE_ROLE_POST: baseurl + 'removerRolUser',
  },

  /**
   * MÓDULO DE CITAS
   */
  login_tipos_usuario: baseurl + 'tipousuario',
  login_login: baseurl + 'login',
  login_logout: baseurl + 'logout',

  // CHEQUEO DE VALIDACION DE USUARIO LOGGEADO
  // PROVEEDOR, CLIENTE, TRABAJADOR COMPRA, BODEGA
  login_validacion: {
    validacion_primera_vez: baseurl + 'validacionInicioLoginPrimeraVez',
    envio_codigo_primera_vez: baseurl + 'EnvioCodigoVerificacionCorreoPrimeraVez',
    codigo_validacion_correo: baseurl + 'ValidacionCorreoPrimeraVez',
    cambio_password_usuario_verificado: baseurl + 'CambioPasswordUserVerificadoPrimeraVez',
  },
  // RECUPERAR CONTRASEÑA
  recover_password: {
    recuperar_contrasena: baseurl + 'RecuperarContrasena',
    verificacion_codigo_contrasena: baseurl + 'VerificarCodigoContrasena',
  },

  // CAMBIO DE CONTRASEÑA DENTRO DEL DASHBOARD ( PARA TODOS LOS TIPOS DE USUARIO )
  change_password_app: baseurl + 'EnvioCodigoCambioPasswordDentroApp',

  // TIPOS DE CITAS
  // Tanto para proveedor como para el área de compras a la hora de crear una cita
  tipos_de_citas: baseurl + 'TiposDeCitas',

  // CITAS DEL USUARIO DE COMPRAS QUE SE ENCUENTRA LOGGEADO
  usuario_compras: {
    citas_del_usuario: baseurl + 'FiltroCitasUsuarioComprasPersonalizado',
    filtro_citas_del_usuario: baseurl + 'GetFiltroCitasEstadosUsuarioComprasPersonalizado/',
  },

  /**
   * DASHBOARD - AREA DE COMPRAS
   * PROVEEDOR CREA LA CITA
   */

  compras_prov_compras: {
    horas_disponibles_pendiente: baseurl + 'VerHorasDisponibleComprasParacrearCitasUserCompra',
    horas_disponibles_pospuesta: baseurl + 'VerHorasDisponibleComprasParaGestionCitasProv',
    ver_detalle: baseurl + 'verDetalleCitaProveedor/',
  },

  // CITA PENDIENTE
  compras_prov_compras_pendiente: {
    // Aceptar, cancelar y posponer
    aceptar_cita: baseurl + 'AceptarCitaProveedor',
    cancelar: baseurl + 'cancelarCitaPendienteUcompras',
    posponer: baseurl + 'PosponerCitaPendienteProveedor',
  },

  // CITA POSPUESTA
  compras_prov_compras_pospuesta: {
    aceptar_cita: baseurl + 'AceptarCitaPospuestaProveedorPorCompra',
    editar_cita: baseurl + 'editarCitaProveedorPospuestaOCompletaUcompra',
    cancelar_pospuesta_completa: baseurl + 'cancelarCitaProveedorPospuestaOCompletaUcompras',
  },

  compras_prov_compras_aceptada: {
    pasar_entrega: baseurl + 'PasarCitasProveedoresEntregaProductos',
  },

  /**
   * DASHBOARD - AREA DE COMPRAS
   * AREA DE COMPRAS CREA LA CITA
   */

  // DASHBOARD
  compras_citas_empleadocompras: baseurl + 'homeEmpleadoscompras',
  compras_citas_empleadocompras_pag: baseurl + 'homeEmpleadoscompras?page=',

  // CREAR CITA
  compras_citas_crear_cita_empleado_compra: baseurl + 'crearcitasEmpleadosCompras',
  // VER DETALLE DE LA CITA
  compras_ver_detalle_cita_compra_compra: baseurl + 'verDetalleCitaCompraPorCompras/',
  // FILTRO DE CITAS AREA DE COMPRAS POR AREA DE COMPRAS
  compras_citas_filtro_compra_compra: baseurl + 'FiltroCitasEstadosComprasPorcompras/',
  // FILTRO DE CITAS POR FECHA INICIO Y FINAL
  compras_citas_filtro_fechas_compra_compra: baseurl + 'filtrosCitasPorFechasUserCompras',
  // FILTRO DE CITAS BUSQUEDA NOMBRE PROVEEDOR Y NIT
  compras_citas_filtro_busqueda: baseurl + 'FiltroCitasPorNombreProveedorYNit/',

  // Horas disponibles para crear una cita o editar una cita recién creada en estado Pendiente
  compras_horas_disponibles_crear_compras: baseurl + 'VerHorasDisponibleComprasParacrearCitasUserCompra',

  // BUSCADOR DE PROVEEDORES
  compras_generarcita_mostrarproveedores: baseurl + 'MostrarProveedores',

  // ||| CITA PENDIENTE |||
  // Eliminar y editar
  compras_eliminar_cita_pendiente_compra_compra: baseurl + 'EliminarCitapendienteComprasPorCompras',
  compras_editar_cita_pendiente_compra_compra: baseurl + 'EditarCitapendienteComprasPorCompras',

  // ||| CITA POSPUESTA |||
  // Horas disponibles para posponer una cita creada por el área de compras
  compras_horas_disponibles_editar_pospuesta: baseurl + 'VerHorasDisponibleComprasParaGestionCitasCompras',
  // Aceptar, cancelar y editar
  compras_aceptar_cita_pospuesta_compra_compra: baseurl + 'AceptarCitaPospuestaComprasPorCompras',
  compras_cancelar_cita_pospuesta_completa_compra_compra: baseurl + 'CancelarCitaComprasPospuestaOCompletaPorCompras',
  compras_editar_cita_pospuesta_completa_compra_compra: baseurl + 'EditarCitaPospuestaOCompletaComprasPorCompras',

  // ||| CITA ACEPTADA |||
  // PASAR CITA A ENTREGA DE PRODUCTO
  compras_pasar_cita_entrega_aceptada_compra_compra: baseurl + 'PasarCitasComprasEntregaProductos',

  // CITAS EN ENTREGA DE PRODUCTOS
  compras_citas_compras_entrega: {
    lista_citas: baseurl + 'MostrarCitasEnEntregaProductosUserComprasGestion',
    ver_detalle: baseurl + 'VerDetalleCitaCompraEntregaUserComprasGestion/',
    ver_detalle_prov: baseurl + 'VerDetalleCitaProveedorEntregaUserComprasGestion/',
    filtro_busqueda: baseurl + 'filtroPorOrdenCompraCitasEntregaUserCompras/',
    editar_fecha_limite_compra: baseurl + 'EditarFechaLimiteCitaEntregaProductCompra',
    editar_fecha_limite_prov: baseurl + 'EditarFechaLimiteCitaEntregaProductProveedor',
    editar_num_orden_compra_compra: baseurl + 'UpdateOrdenCompraCcompras',
    editar_num_orden_compra_prov: baseurl + 'UpdateOrdenCompraCproveedor',
  },

  /*****************************************/
  /*****************************************/
  /*****************************************/
  /*****************************************/
  /*****************************************/

  /**
   * DASHBOARD PROVEEDOR
   * PROVEEDOR CREA LA CITA
   */
  proveedor_home: {
    // Retorna los pagos de los proveedores por parte de tiresia
    PAYMENT_LIST: baseurl + 'pagosProveedores',
  },

  // DASHBOARD
  proveedor_home_proveedor: baseurl + 'homeProveedores',
  // LISTA DE CITAS
  proveedor_ver_citas: baseurl + 'MostrarCitasProveedores',
  proveedor_ver_citas_pag: baseurl + 'MostrarCitasProveedores?page=',
  // CREAR CITA
  proveedor_crearcita: baseurl + 'crearCitasProveedor',
  proveedor_horas_disponibles_crear_proveedor: baseurl + 'VerHorasDisponibleProveedoresParacrearCitas',
  // VER DETALLE DE CITA
  proveedor_ver_detalle_cita_prov_prov: baseurl + 'verDetalleCitaProveedorPorElProvedor/',

  /**********************************************************
   *     DASHBOARD _ QUIEN CREA _ QUIEN ACTUA _ ESTADO    *
   *********************************************************/

  // CITA PENDIENTE
  proveedor_prov_prov_pendiente: {
    editar_cita: baseurl + 'EditarCitaPendienteProveedorPorElProveedor',
    eliminar_cita: baseurl + 'EliminarCitaPendienteProveedorPorProveedor',
  },

  // CITA POSPUESTA
  proveedor_prov_prov_pospuesta: {
    aceptar_cita: baseurl + 'AceptarCitaPospuestaProveedorPorProveedor',
    editar_cita: baseurl + 'EditarCitaPospuestaOCompletaProveedorPorElProveedor',
    cancelar_cita: baseurl + 'CancelarCitaProveedorPospuestaOcompletaPorProveedor',
    ver_horas_disponibles: baseurl + 'VerHorasDisponibleProveedoresParaGestionCitasProv',
  },

  // Filtro de citas Proveedor por Proveedor
  proveedor_citas_filtro_prov_prov: baseurl + 'FiltroCitasEstadosProveedorPorProveedor/',

  // Lista de Depositos
  proveedor_mostrar_depositos: baseurl + 'Mostrardepositos',

  /**
   * DASHBOARD PROVEEDOR
   * AREA DE COMPRAS CREA LA CITA
   */

  // Ver horas disponibles para posponer una cita creada por compras
  proveedor_compras_prov: {
    horas_disponibles: baseurl + 'VerHorasDisponibleProveedoresParaGestionCitasCompras',
    ver_detalle_cita: baseurl + 'verDetalleCitaCompraPorElProvedor/',
  },

  /**********************************************************
   * DASHBOARD | QUIEN CREA | QUIEN REALIZA ACCION | ESTADO *
   *********************************************************/

  // CITA PENDIENTE
  proveedor_compras_prov_pendiente: {
    // Aceptar, cancelar y posponer
    aceptar_cita: baseurl + 'AceptarCitaPendientePorCompraProveedores',
    cancelar_pendiente: baseurl + 'CancelarCitaPendientePorCompraProveedores',
    posponer: baseurl + 'PosponerCitaPendientePorCompraProveedores',
  },

  // CITA POSPUESTA por Proveedor
  proveedor_compras_prov_pospuesta: {
    aceptar_cita_pospuesta: baseurl + 'AceptarCitaPospuestaCompraPorProveedor',
    cancelar_cita_pospuesta_completa: baseurl + 'CancelarCitaCompraPospuestaOcompletaPorProveedores',
    editar_cita_pospuesta_completa: baseurl + 'editarCitaPospuestaGeneradaPorCompraOCompletaUProveedor',
  },

  // CITAS EN ENTREGA DE PRODUCTO POR PROVEEDOR

  proveedor_entrega: {
    lista_citas_entrega: baseurl + 'MostrarCitasEntregaDeProductosProveedores',
    ver_detalle: baseurl + 'VerDetalleCitaCompraEntregaUserProveedor/',
    ver_detalle_prov: baseurl + 'VerDetalleCitaProveedorEntregaUserProveedor/',
    // Viejo
    filtro_estado: baseurl + 'filtroPorEstadosCitasEntregasProveedor/',
    // Nuevo
    filtrar_por_estado: baseurl + 'filtroScopeCitasEntregaProdProveedor',
  },

  /*****************************************/
  /*****************************************/
  /*****************************************/
  /*****************************************/
  /*****************************************/

  /**
   * DASHBOARD BODEGA
   * PARA MANEJO DE CITAS EN ENTREGA DE PRODUCTOS
   */

  bodega: {
    dashboard: baseurl + 'homeEmpleadoBodega?page=',
    filtro_ordenes: baseurl + 'filtroPorEstadosCitasEntregasUserBodega/',
    tipo_documento: baseurl + 'MostrarTipoDocumento',
    busqueda: baseurl + 'filtrosOrdenCompraAsincrono/',
  },

  /**
   * MANEJO DE CITAS CREADAS POR DEPOSITO COMPRAS
   */
  bodega_compra_cita_pendiente: {
    gestion_documento: baseurl + 'GestionarCitasDetOrdenComprasEntregaUserBodega',
    cancelar_orden: baseurl + 'cancelarCitaCompraPendienteEntregaUserBodega',
  },
  bodega_compra_cita_agendada: {
    ver_detalle: baseurl + 'VerDetalleCitaCompraEntregaUserBodegaGestion/',
    editar_documento: baseurl + 'EditarDocCompraCompraEntregasAgendadasUserBodega',
    cancelar_documento: baseurl + 'cancelarDocumentosDetOrdenCompraCitasCompras',
    pasar_entrega_exitosa: baseurl + 'pasarCitasComprasEntregaDeproductoExitosa',
  },
  /**
   * MANEJO DE CITAS CREADAS POR PROVEEDOR
   */
  bodega_prov_cita_pendiente: {
    gestion_documento: baseurl + 'GestionarCitasDetOrdenProvEntregaUserBodega',
    cancelar_orden: baseurl + 'cancelarCitaProveedorePendienteEntregaUserBodega',
  },
  bodega_prov_cita_agendada: {
    ver_detalle: baseurl + 'VerDetalleCitaProveedorEntregaUserBodegaGestion/',
    editar_documento: baseurl + 'EditarDocCompraProveedorEntregasAgendadasUserBodega',
    cancelar_documento: baseurl + 'cancelarDocumentosDetOrdenCompraCitasProveedores',
    pasar_entrega_exitosa: baseurl + 'pasarCitasProveedoresEntregaDeproductoExitosa',
  },

  /**
   * API TIRESIA
   * DASHBOARD CLIENTES
   */
  tiresia: {
    LOGIN: baseurl + 'sesionTiresia',
    HOME_CLIENTES: baseurl + 'homeClientes',
    CLIENT_PRODUCTS: baseurl + 'getAllProductsCliente',
    CLIENT_BILLS: baseurl + 'filtroFechasFacturasClientes',
    CLIENT_BILL_DETAILS: baseurl + 'verDetalleFacturaTiresia',
    CLIENT_BILL_RECEIPTS: baseurl + 'getReciboCajasFactura',
    CLIENT_WALLET: baseurl + 'getCarteraCliente',
    CLIENT_WALLET_MOVEMENT: baseurl + 'getMovimientoCarteraCliente',
    CLIENT_ACCESS_TO_ORDER: baseurl + 'clientCredentials',
  },

  /**
   * LOG DE ERRORES
   */
  error: {
    envioSinToken: baseurl + 'insertLogError',
    envioConToken: baseurl + 'insertLogErrorAuth',
  },

  /**
   * Descarga de PDF Tiresia
   * Esta ruta se utiliza para:
   * Clientes: PDF de cada factura.
   * Empleados de Unidrogas: PDF del certificado laboral
   * y PDF del certificado de retencion.
   */
  DOWNLOAD_PDF_TIRESIA_CERTIFICADO_LABORAL: baseurl + 'pdfComprobanteNomina',
  DOWNLOAD_PDF_TIRESIA_FUENTE_INGRESO: baseurl + 'traerPdfTiresia',
  DOWNLOAD_PDF_TIRESIA_PAGO_DE_NOMINA: baseurl + 'pdfComprobanteNomina ',
  DOWNLOAD_QR_TIRESIA_CERTIFICADO_LABORAL: baseurl + 'certificadosEmpleadoQR',

  empleado_unidrogas: {
    tipos_certificado_GET: baseurl + 'tiposCertificadoEmpleado',
    certificado_POST: baseurl + 'certificadosEmpleado',
    certificado_sena: baseurl + 'certificadoLaboralAprendices',
    // ENCUESTAS
    GET_ENCUESTAS_EMPLEADOS: baseurl + 'getEncuestasEmpleados',
    GET_DETALLE_ENCUESTA: baseurl + 'verDetalleEncuestaEmpleado',
    POST_RESPONDER_ENCUESTA: baseurl + 'responderEncuesta',
  },
  /**
   * ADMIN TALENTO HUMANO
   */
  admin_talento: {
    // AUSENTISMO
    GET_LISTA_AUSENTISMO: baseurl + 'getAusentimosAdminTh',
    GET_ESTADISTICAS_AUSENTISMO: baseurl + 'estadisticasAusentismoTh',
    // RETIRO DE CESANTIAS
    GET_LISTA_CESANTIAS: baseurl + 'getCesantiasAdminTh',
    GET_DETALLE_CESANTIA: baseurl + 'verDetalleCesantiaAdminTh',
    // ENCUESTAS
    GET_LISTA_ENCUESTAS: baseurl + 'getEncuestasAdminTH',
    GET_DETALLE_ENCUESTAS: baseurl + 'verDetalleEncuestaAdminTh',
  },
  /**
   * TALENTO HUMANO
   */
  talento: {
    GET_ENCUESTAS_ADMIN_TH: baseurl + 'getEncuestasAdminTh',
    POST_CREAR_ENCUESTA: baseurl + 'crearEncuestas',
    GET_TIPO_PREGUNTAS: baseurl + 'getTipoPreguntas',
    GET_TIPO_RESPUESTA_PREGUNTA: baseurl + 'getTipoRespuestaPregunta',
    GET_TIPO_PRIVACIDAD_PREGUNTA: baseurl + 'getTipoPrivacidadPregunta',
    POST_CREAR_PREGUNTAS: baseurl + 'crearPreguntas',
    GET_VER_DETALLE_ENCUESTA_TH: baseurl + 'verDetalleEncuestaTh',
    POST_ELIMINAR_PREGUNTA_ENCUESTA_TH: baseurl + 'eliminarPreguntasTh',
    POST_EDITAR_ENCUESTA: baseurl + 'editarEncuesta',
    POST_AGREGAR_QUITAR_RESPUESTA_PREGUNTA_SELECCION_MULTIPLE: baseurl + 'agregarOquitarRespuesta',
    POST_ACTUALIZAR_PREGUNTAS_RESPUESTAS_TH: baseurl + 'actualizarPreguntasTh',
    GET_FILTRO_ENCUESTA: baseurl + 'filtrosEncuesta',
    GET_BUSCAR_USUARIO: baseurl + 'buscarEmpleado',
    POST_ANULAR_TH_AUSENTISMO: baseurl + 'anularAusentismoTh',
    POST_ELIMINAR_RECHAZADOS_TH_AUSENTISMO: baseurl + 'eliminarSolicitudTh',
  },
  /**
   * Ausentismo
   */
  ausentismo: {
    GET_TIPO_AUSENCIA: baseurl + 'getTipoAusencia',
    GET_MOTIVOS_AUSENTISMO: baseurl + 'getMotivoAusentismo',
    GET_ESTADO_AUSENTISMO: baseurl + 'getEstadoAusentismo',
    GET_JEFE_DIRECTO_INMEDIATO: baseurl + 'buscarJefeInmediato',
    // talento humano
    GET_REGISTROS_AUSENTISMO: baseurl + 'getRegistrosAusentismoTh',
    POST_RESPONDER_REGISTRO: baseurl + 'responderSolicitudTh',
    GET_ESTADISTICAS_AUSENTISMO: baseurl + 'estadisticasAusentismo',
    // empleado
    GET_REGISTROS_AUSENTISMO_EMP: baseurl + 'getAusentismoEmpleado',
    GET_REGISTROS_AUSENTISMO_RECEPCIONISTA: baseurl + 'getAusentismoRecepcionista',
    POST_REGISTRO_AUSENTISMO_EMP: baseurl + 'registroAusentismo',
    POST_ELIMINAR_REGISTRO_AUSENTISMO_EMP: baseurl + 'eliminarSolicitudEmpleado',
    POST_EDITAR_REGISTRO_AUSENTISMO_EMP: baseurl + 'editarSolicitudEmpleado',
    // Jefe inmediato (todos los empleados sin importal el rol, pueden ser un jefe inmediato)
    GET_TODAS_SOLICITUDES_DE_ASUSENTISMO_PARA_JEFE_INDMEDIATO: baseurl + 'getRegistrosJefeInmediato',
    POST_RESPONDER_SOLICITUD_AUSENTISMO_JEFE_INMEDIATO: baseurl + 'responderSolicitudJefeI',
  },
  /**
   * Aspirantes
   */
  aspirantes: {
    // Rutas para admin
    GET_LISTA_ASPIRANTES_ADMIN: baseurl + 'aspirantes/admin/listar',
    POST_CREAR_ASPIRANTE_ADMIN: baseurl + 'aspirantes/admin/crear',
    PUT_EDITAR_ASPIRANTE_ADMIN: baseurl + 'aspirantes/admin/editar',
    POST_CREAR_CARGO_ASPIRANTE_ADMIN: baseurl + 'aspirantes/admin/cargos/crear',
    GET_LISTA_CARGOS_ASPIRANTE_ADMIN: baseurl + 'aspirantes/admin/cargos/listar',
    GET_LISTA_ANEXOS_ASPIRANTE_ADMIN: baseurl + 'aspirantes/admin/anexos/listar',
    POST_AGREGAR_ANEXO_ASPIRANTE_ADMIN: baseurl + 'aspirantes/admin/anexos/agregar',
    DELETE_ELIMINAR_ANEXO_ASPIRANTE_ADMIN: baseurl + 'aspirantes/admin/anexos/eliminar',
    POST_AGREGAR_CARGO_CONTRATACION_ASPIRANTE_ADMIN: baseurl + 'aspirantes/admin/contratacion/agregar-cargo',
    PUT_EDITAR_CARGO_CONTRATACION_ASPIRANTE_ADMIN: baseurl + 'aspirantes/admin/contratacion/editar-cargo',
    PUT_CAMBIAR_ESTADO_CONTRATACION_ASPIRANTE_ADMIN: baseurl + 'aspirantes/admin/contratacion/cambiar-estado',

    // Rutas para aspirantes
    GET_MIS_CONTRATACIONES_ASPIRANTE: baseurl + 'aspirantes/mis-contrataciones',
  },

  /**
   * Cesantias
   */
  cesantias: {
    // EMPLEADO Y TH
    GET_ESTADO_CESANTIAS_EMP_TH: baseurl + 'getEstadoCesantiasPublic',
    GET_TIPO_DESTINACION_CESANTIAS: baseurl + 'getDestinacionCesantias',
    GET_FONDOS_CESANTIAS: baseurl + 'getFondoPensiones',
    GET_TIPO_VALOR_CESANTIAS: baseurl + 'getTipoValorCesantias',
    GET_TIPO_PAGO_CESANTIAS: baseurl + 'getTipoPagoCesantias',
    // EMPLEADO
    GET_CESANTIAS_EMPLEADO: baseurl + 'getCesantiasEmpleados',
    GET_REQUISITOS_DESTINACION_CESANTIAS: baseurl + 'getRequisitosDestinacionId',
    POST_CREAR_REGISTRO_CESANTIAS: baseurl + 'registroCesantias',
    GET_VER_DETALLE_CESANTIA_EMP: baseurl + 'verDetalleCesantiaEmpleado',
    // ADMIN CENSANTIAS
    GET_ADMIN_CESANTIAS_ALL: baseurl + 'getCesantiasAll',
    GET_DETAILS_ADMIN_CESANTIAS: baseurl + 'verDetalleCesantiasAll',
    POST_RESPONSE_ADMIN_CENSATIAS: baseurl + 'ResponderCesantiasAll',
    // TH
    GET_CESANTIAS_TH: baseurl + 'getRegistroCesantiasTh',
    GET_VER_DETALLE_CESANTIA_TH: baseurl + 'verDetalleCesantiasTh',
    GET_ESTADO_CESANTIAS_TH: baseurl + 'getEstadoCesantiasTh',
    POST_RESPONDER_CESANTIA_TH: baseurl + 'responderSolicitudCesantiasTh',
  },

  soat: {
    GET_VEHICLES: 'https://girosya.superat.com.co/api/view_vehicle_types',
    GET_DETAIL_VEHICLE: 'https://girosya.superat.com.co/api/vehicle_type',
    GET_SOAT_COST: 'https://girosya.superat.com.co/api/soat_cost',
    POST_SOAT_COTIZAR: baseurl + 'cotizacionSoat',
  },

  gestion_documental: {
    POST_UPDATE_FOLDER: baseurl + 'updateFolderOrDoc',
    POST_UPDATE_ROL: baseurl + 'updatePermisosDoc',
    POST_DALTE_ARCHIVE: baseurl + 'deletefolderOrDoc',
    POST_CREATE_FOLDER: baseurl + 'saveFolderOrDoc',
    GET_SEARCH_DOCUMENT_TH: baseurl + 'BuscadorDocTh',
    GET_ALL_FOLDER_TH: baseurl + 'getRaizFolderOrDocTh',
    GET_DETAIL_FOLDER_TH: baseurl + 'getDetalleFolderOrDocTh',
    GET_CONTAIN_FOLDER_TH: baseurl + 'getContenidoFolderTh',
    GET_ROLES_PERMISOS_TH: baseurl + 'getRoles',
    GET_ROLES_USERS_CARGO: baseurl + 'getRolehasUsers',
    GET_ALL_FOLDER_EMPLEADO: baseurl + 'getRaizDocEmpleado',
    GET_DETAIL_FOLDER_EMPLEADO: baseurl + 'getDetalleFolderOrDoc',
    GET_CONTAIN_FOLDER_EMPLEADO: baseurl + 'getContenidoFolderEmpleado',
    GET_SEARCH_DOCUMENT_EMPLEADO: baseurl + 'BuscadorDocEmpleado',
  },

  licencia: {
    POST_CREATE_REQUEST_CORABORATE: baseurl + 'registroLicencias',
    GET_LIST_COLABORATE: baseurl + 'getLicenciaEmpleado',
    GET_DEAILS_LICENSE_COLABORATE: baseurl + 'getDetalleLicenciaEmpleado',
    GET_TYPE_LICENSE: baseurl + 'getTipoLicencia',
    GET_DETAILS_DOC_TYPE_LICENSE: baseurl + 'getDocTipoLicencia',
    GET_LIST_REQUEST_DIRECTO_BOSS: baseurl + 'getLicenciasJefeInmidiato',
    GET_DETAILS_REQUEST_DIRECT_BOSS: baseurl + 'getDetalleLicenciaJefe',
    POST_DELETE_REQUEST: baseurl + 'eliminarSolicitudLicenciaEmpleado',
    GET_DIAX_LICE: baseurl + 'getFormulaDiagnostico',
    GET_PARENTESCO: baseurl + 'parentescosLicencia',
  },
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
